import makeTable from '../../components/makeTable.jsx';

export const UrlTable = makeTable([
  ['URL', 75],
  ['Outbound', 10],
  ['Issue count', 15],
]);
